/**
 * A wrapper class for local storage. Primarily manages expiration of local storage data.
 */
class LocalStorageService {

  constructor() {
    if (!LocalStorageService._instance) {
      LocalStorageService._instance = this;
    }

    return LocalStorageService._instance;
  }

  setItem(key, value) {
    // Default expire time is 8 hours.
    const timeToExpire = 8 * 60 * 60 * 1000;

    const storageItem = {
      value: value,
      expires: new Date().getTime() + timeToExpire,
    }

    localStorage.setItem(key, JSON.stringify(storageItem));
  }

  getItem(key) {
    let storageItem = localStorage.getItem(key);

    if (storageItem) {
      storageItem = JSON.parse(storageItem);
    }

    if (typeof storageItem === 'object' && storageItem !== null && Object.prototype.hasOwnProperty.call(storageItem, 'expires')) {
      if (new Date().getTime() > storageItem.expires) {
        this.deleteItem(key);
        storageItem = null;
      }
      else {
        storageItem = storageItem.value;
      }
    }

    return storageItem;
  }

  deleteItem(key) {
    localStorage.removeItem(key);
  }

}

const instance = new LocalStorageService();

export default instance;